module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/operator.be05c161.svg";